// Generated by CoffeeScript 2.7.0
var Admin__Settings__NamespaceStatusController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsNamespaceStatus from 'trunks/vue/admin/components/settings/settings_container/settings_namespace_status.js';

export default Admin__Settings__NamespaceStatusController = (function() {
  class Admin__Settings__NamespaceStatusController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return new SettingsNamespaceStatus({
        el: DomMaster.find("#js-settings-namespace_status").node,
        propsData: {
          activeTab: 'namespace_status',
          namespaceStatus: this.getVars()
        }
      });
    }

  };

  Admin__Settings__NamespaceStatusController.include(GenerateMorePopover);

  Admin__Settings__NamespaceStatusController.include(SettingsNavigator);

  return Admin__Settings__NamespaceStatusController;

}).call(this);
